/**
 * SectionHeading - Generic section heading with icon and text
 *
 * Displays an icon, subtitle, and title. Used throughout the app for
 * section headers (e.g., "New Listings", "Live Auctions").
 *
 * @param {Object} props
 * @param {string} props.img - Icon/image URL
 * @param {string} props.text - Subtitle/descriptor text
 * @param {string} props.title - Main heading title
 * @returns {React.ReactElement} Rendered section heading
 */
const SectionHeading = ({img , text , title}) => {

  return (
      <div className="container-fluid section-heading d-flex mt-20 mb-15">
        <div className="img-div mr-10"><img src={img} alt="" /></div>
        <div className="d-flex flex-column h-100">
          <p className="mb-1 pt-2 text-bold text-light">{text}</p>
          <h5 className="font-weight-bolder text-light">{title}</h5>
        </div>
      </div>
  );
}

export default SectionHeading;
